// extracted by mini-css-extract-plugin
export default {"header":"DQJo6","color":"Fs6Xc","link":"w4jXP","nav":"owO5d","fadeInDown":"_qJVi"};